import React, { useEffect, useState } from "react";
import type { TableProps } from "antd";
import { Table } from "antd";
import { filterExam, getAtcExams } from "../../redux/apiActions/examActions";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { Exam } from "../../redux/apiSlice/examSlice";
import moment from "moment";
import { getCommonState, getExamState } from "../../redux/store/getState";
import modifyId from "../../utils/modifyId";
import useSearch from "../../hooks/useSearch";
import { clearFilterValues } from "../../redux/apiSlice/commonSlice";
import { EXAM_STATUS } from "../../utils/status";
import useUser from "../../hooks/useUser";

type ColumnsType<T extends object = object> = TableProps<T>["columns"];

const ATCExamTable: React.FC = () => {
  const dispatch = useAppDispatch();
  const { atcExams, loading } = useAppSelector(getExamState);
  const { filterFrom, filterTo } = useAppSelector(getCommonState);
  const [data, setData] = useState<Exam[]>();
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const { user } = useUser();
  useSearch(atcExams, setData);

  useEffect(() => {
    if (filterFrom && filterTo) {
      dispatch(filterExam({ from: filterFrom, to: filterTo }));
    } else {
      if (user?.atc.id) dispatch(getAtcExams(user.atc.id));
    }
  }, [filterFrom, filterTo, dispatch, user]);

  useEffect(() => {
    return () => {
      dispatch(clearFilterValues());
    };
  }, [dispatch]);

  const columns: ColumnsType<Exam> = [
    {
      title: "Date and Time",
      dataIndex: "created_at",
      render: (created_at) =>
        `${moment(created_at).format("DD/MM/YYYY hh:mmA")}`,
    },
    {
      title: "Student ID",
      dataIndex: "id",
      render: (id) => `${modifyId(id)}`,
    },
    {
      title: "Username",
      dataIndex: "user",
      render: (user) => <>{user.username}</>,
    },
    {
      title: "Exam Name",
      dataIndex: "exam",
      render: (exam) => <>{exam.name}</>,
    },

    {
      title: "Slot Booking Time",
      dataIndex: "time",
      render: (time) => <>{moment.unix(time).format("MM/DD/YYYY hh:mmA")}</>,
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status) => <>{EXAM_STATUS[status] || status}</>,
    },
  ];

  return (
    <Table
      scroll={{ x: 300 }}
      style={{ marginTop: 20, whiteSpace: "pre", width: "100%" }}
      loading={loading.getExam || loading.deleteExam}
      columns={columns}
      rowKey={(record) => record.id}
      dataSource={data}
      onChange={(p) =>
        setPagination({ current: p.current || 1, pageSize: p.pageSize || 10 })
      }
      pagination={pagination}
      rowClassName={(_, index) => (index % 2 === 0 ? "tr-light" : "tr-dark")}
    />
  );
};

export default ATCExamTable;
